
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"18","height":"18"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"audio","d":"M9.75 1v12a.75.75 0 01-1.2.6l-4.467-3.35H2.5A1.75 1.75 0 01.75 8.5v-3c0-.966.784-1.75 1.75-1.75h1.582L8.55.4a.75.75 0 011.2.6zm3.75.104a.752.752 0 011.06.058C15.986 2.756 16.79 4.816 16.79 7s-.804 4.245-2.233 5.838a.749.749 0 11-1.116-1.001A7.211 7.211 0 0015.29 7a7.22 7.22 0 00-1.849-4.837.75.75 0 01.058-1.059zM8.25 2.5L4.782 5.1a.753.753 0 01-.45.15H2.5a.25.25 0 00-.25.25v3c0 .138.112.25.25.25h1.833c.162 0 .32.053.45.15l3.467 2.6v-9zm3.254 1.293a.751.751 0 011.059.066A4.734 4.734 0 0113.75 7c0 1.172-.427 2.28-1.187 3.14a.75.75 0 11-1.125-.991c.52-.59.812-1.346.812-2.149 0-.803-.292-1.559-.812-2.149a.75.75 0 01.066-1.058z"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","transform":"translate(0 2)"}},[_c('mask',{attrs:{"id":"aud","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#audio"}})]),_c('use',{attrs:{"fill":"#979797","fill-rule":"nonzero","xlink:href":"#audio"}}),_c('g',{attrs:{"fill":"#FFF","mask":"url(#aud)"}},[_c('path',{attrs:{"d":"M-3-5h24v24H-3z"}})])])])
          )
        }
      }
    